import { Box, Typography } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import moment from "moment";
import "moment/locale/es";
import { TGetServiceHolderResponse } from "../../../../../../../../api/serviceHolder/apiGetServiceHolder";

const StyledWrapper = styled(Box)``;

const StyledName = styled(Typography)`
  font-size: 0.9375rem;
  font-weight: 600;
`;

const StyledBirthDate = styled(Typography)`
  font-size: 0.75rem;
  font-weight: 400;
`;

interface IServiceHolderDetailProps {
  serviceHolder: TGetServiceHolderResponse;
}

const ServiceHolderDetail = (props: IServiceHolderDetailProps) => {
  const { serviceHolder } = props;

  let birthDate = null;
  if (serviceHolder.Fecha_de_nacimiento_U1) {
    const bDate = moment(serviceHolder.Fecha_de_nacimiento_U1);
    birthDate = (
      <StyledBirthDate>
        {bDate.format("DD/MM/YYYY")} - {moment().diff(bDate, "years", false)}
      </StyledBirthDate>
    );
  }

  return (
    <StyledWrapper>
      <StyledName>
        {serviceHolder.Nombre_U1} {serviceHolder.Primer_apellido_U1}{" "}
        {serviceHolder.Segundo_apellido_U1}
      </StyledName>
      {birthDate}
    </StyledWrapper>
  );
};

export default ServiceHolderDetail;
